module.exports = __webpack_public_path__ + "img/third.564cbc1e.jpg";